import { ITeamSquadItem } from '../../../../packages/types';
import { TeamPlayerStat } from '../types';

export const getTeamPlayerStatValue = (stat: TeamPlayerStat, item: ITeamSquadItem, playerAge: number) => {
  if (stat === 'playerAge') {
    return playerAge || '-';
  }

  return item[stat] ? item[stat] : '0';
};
